module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "homeView"
    }
  }, [_c('div', {
    staticClass: "lately-wrapper"
  }, [_c('prevheader', {
    attrs: {
      "title": "最近播放"
    }
  }), _vm._v(" "), _c('scroll', {
    attrs: {
      "data": _vm.items
    }
  }, [_c('div', {
    staticClass: "lately-content"
  }, [(_vm.items.length) ? _c('songlist', {
    attrs: {
      "songs": _vm.items
    }
  }) : _c('p', {
    staticStyle: {
      "padding": "20px"
    }
  }, [_vm._v("暂时没有播放记录")])], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-5d086178"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/view/lately/lately.vue
// module id = 207
// module chunks = 1